import { render, staticRenderFns } from "./modify-permission-group.modal.vue?vue&type=template&id=55a9b281&"
import script from "./modify-permission-group.modal.vue?vue&type=script&lang=js&"
export * from "./modify-permission-group.modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports